export const LITA_CHAT_LOCALHOST = `http://localhost:3005`;
export const LITA_CHAT_VERCEL_URL = `https://holalita.vercel.app/`;
